/** @jsxImportSource @emotion/react */
import { css, keyframes } from '@emotion/react';
import * as React from 'react';
import { withMyTheme } from '../theme/theme';

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    visibility: hidden;
  }
`;

const LoadingIndicatorStyle = withMyTheme((theme) => css`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${theme.palette.background.default};
  z-index: 9999;
  transition: opacity 0.5s ease-out, visibility 0.5s ease-out;
  &.loaded {
    animation: ${fadeOut} 0.8s forwards;
  }
`);

const spinnerAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerStyle = withMyTheme((theme) => css`
  width: 60px;
  height: 60px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: ${theme.palette.primary.main};
  animation: ${spinnerAnimation} 1s ease-in-out infinite;
`);

interface LoadingIndicatorProps {
  isLoading: boolean;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ isLoading }) => {
  return (
    <div css={LoadingIndicatorStyle} className={isLoading ? '' : 'loaded'}>
      <div css={SpinnerStyle}></div>
    </div>
  );
};
